module.exports = __webpack_public_path__ + "img/logo.693238b7.svg";